import {
  FETCH_HISTORY_LOGS, RESET_ALL_HISTORY_LOGS, SHOW_HISTORY_LOGS,
} from './actions';

// Initial State
const initialState = {
  logs: {}, // indexed by opportunityId
  currentOpportunity: null,
  currentLogType: null,
};


const HistoryLogReducer = (state = initialState, action) => {
  switch (action.type) {
    case FETCH_HISTORY_LOGS: {
      const {
        opportunityId, logDetails, errors, status,
      } = action;
      const currentLog = state.logs[opportunityId] || {};
      const newLogs = {
        ...currentLog,
        logs: logDetails,
        errors,
        status,
      };
      return {
        logs: {
          ...state.logs,
          [opportunityId]: newLogs,
        },
      };
    }
    case RESET_ALL_HISTORY_LOGS: {
      return {
        logs: {}, // clear all
        currentOpportunity: null,
        currentLogType: null,
      };
    }
    case SHOW_HISTORY_LOGS: {
      const { opportunity, logType } = action;
      return {
        ...state,
        currentOpportunity: opportunity,
        currentLogType: logType,
      };
    }
    default:
      return state;
  }
};

export const getLoaded = (state, opportunityId) => {
  const currentLogs = state.historyLogs.logs[opportunityId];
  return currentLogs && currentLogs.status === 'loaded';
};
export const getLoading = (state, opportunityId) => {
  const currentLogs = state.historyLogs.logs[opportunityId];
  return currentLogs && currentLogs.status === 'loading';
};
export const getLogs = (state, opportunityId, type) => {
  const currentLogs = state.historyLogs.logs[opportunityId];
  if (currentLogs && currentLogs.status === 'loaded' && currentLogs.logs) {
    return currentLogs.logs[type] || [];
  }
  return [];
};
export const getFetched = (state, opportunityId) => {
  const currentLogs = state.historyLogs.logs[opportunityId];
  return currentLogs !== undefined;
};

export const getCurrentOpportunity = state => state.historyLogs.currentOpportunity;
export const getCurrentLogType = state => state.historyLogs.currentLogType;

// Export Reducer
export default HistoryLogReducer;
